let ctn_input = document.querySelectorAll(".input-row");
let input = document.querySelectorAll(".input-row input");
let showPassword = document.querySelectorAll(".show_password");
let inputPassword = document.querySelectorAll(".customer_password");

let itemSelect = document.querySelectorAll(".item_select");
let tab = document.querySelectorAll(".tab");

input.forEach((inputElement) => {
  inputElement.addEventListener("focus", () => {
    ctn_input.forEach((row) => {
      const rowInput = row.querySelector("input");
      if (rowInput && rowInput.value.length === 0) {
        row.classList.remove("active");
      }
    });
    inputElement.closest(".input-row").classList.add("active");
  });

  inputElement.addEventListener("keyup", () => {
    const label = document.querySelector(`label[for="${inputElement.id}"]`);
    const row = inputElement.closest(".input-row");

    if (inputElement.value.length > 0) {
      label.style = "font-size: 12px;";
      row.classList.add("active");
    } else {
      label.style = "font-size: 16px;";
    }
  });

  inputElement.addEventListener("blur", () => {
    if (inputElement.value.length === 0) {
      inputElement.closest(".input-row").classList.remove("active");
    }
  });
});

// Focus email field and show popup when clicking "Find My Order"
document.addEventListener('DOMContentLoaded', function () {
  const findOrderLink = document.getElementById('find-order-link');
  const emailInput = document.getElementById('customer_email');
  const orderPopup = document.getElementById('orderPopup');
  const signInTab = document.querySelector('.ctn_btn .tab');

  if (findOrderLink && emailInput && orderPopup) {
    findOrderLink.addEventListener('click', function (e) {
      e.preventDefault();
      if (signInTab && !signInTab.classList.contains('active')) {
        signInTab.click();
      }
      emailInput.focus();
      orderPopup.style.display = 'block';
      setTimeout(function () {
        orderPopup.style.display = 'none';
      }, 4000);
    });
  }
});

// Ocultar inicialmente el botón de mostrar/ocultar contraseña
showPassword.forEach((showPasswordElement) => {
  showPasswordElement.style.display = "none";

  // Alternar entre mostrar y ocultar contraseña
  showPasswordElement.addEventListener("click", () => {
    if (inputPassword.type === "password") {
      inputPassword.type = "text";
      document.querySelector(".show_logo").style.display = "none";
      document.querySelector(".hide_logo").style.display = "block";
    } else {
      inputPassword.type = "password";
      document.querySelector(".show_logo").style.display = "block";
      document.querySelector(".hide_logo").style.display = "none";
    }
  });
});

// Mostrar/ocultar botón de mostrar contraseña según el contenido de cada input de contraseña
inputPassword.forEach((inputPasswordElement, idx) => {
    // Selecciona el showPassword correspondiente al inputPassword actual
    let showPasswordElement = showPassword[idx];

    // Ocultar el botón inicialmente
    if (showPasswordElement) showPasswordElement.style.display = "none";

    // Mostrar u ocultar el botón según si hay contenido en el campo
    inputPasswordElement.addEventListener("input", () => {
        if (inputPasswordElement.value.length > 0) {
        if (showPasswordElement) showPasswordElement.style.display = "block";
        // Mostrar el icono correcto según el estado actual
        if (inputPasswordElement.type === "password") {
            showPasswordElement.querySelector(".show_logo").style.display = "block";
            showPasswordElement.querySelector(".hide_logo").style.display = "none";
        } else {
            showPasswordElement.querySelector(".show_logo").style.display = "none";
            showPasswordElement.querySelector(".hide_logo").style.display = "block";
        }
        } else {
        if (showPasswordElement) showPasswordElement.style.display = "none";
        }
    });

    // Alternar mostrar/ocultar contraseña al hacer click en el botón
    if (showPasswordElement) {
        showPasswordElement.addEventListener("click", () => {
        if (inputPasswordElement.type === "password") {
            inputPasswordElement.type = "text";
            showPasswordElement.querySelector(".show_logo").style.display = "none";
            showPasswordElement.querySelector(".hide_logo").style.display = "block";
        } else {
            inputPasswordElement.type = "password";
            showPasswordElement.querySelector(".show_logo").style.display = "block";
            showPasswordElement.querySelector(".hide_logo").style.display = "none";
        }
        });
    }
});

// Tab
tab.forEach((tabElement, index) => {
  tabElement.addEventListener("click", () => {
    tab.forEach((tab) => tab.classList.remove("active"));
    tabElement.classList.add("active");
    itemSelect.forEach((item) => item.classList.remove("active"));
    itemSelect[index].classList.add("active");
  });
});

// Configurar todos los tooltips con una sola clase
document.querySelectorAll('.details-link').forEach(function(detailsLink) {
    const detailsTrigger = detailsLink.querySelector('a');
    const detailsModal = detailsLink.querySelector('.details-modal');
    
    if (detailsTrigger && detailsModal) {
        // Mostrar tooltip al pasar el mouse sobre el enlace "Details"
        detailsLink.addEventListener('mouseenter', function() {
            detailsModal.style.display = 'block';
        });
        
        // Ocultar tooltip al quitar el mouse del enlace
        detailsLink.addEventListener('mouseleave', function() {
            // Pequeño retraso para permitir que el mouse entre en el tooltip
            setTimeout(function() {
                // Solo ocultar si el mouse no está sobre el tooltip
                if (!detailsModal.matches(':hover')) {
                    detailsModal.style.display = 'none';
                }
            }, 100);
        });
        
        // También ocultar el tooltip cuando el mouse sale del tooltip
        detailsModal.addEventListener('mouseleave', function() {
            detailsModal.style.display = 'none';
        });
    }
});

// Elementos para el progreso del autoplay
const progressBar = document.querySelector(".autoplay-progress .progress-bar-inner");
const autoplayToggle = document.querySelector(".autoplay-toggle");
const pauseIcon = document.querySelector(".pause-icon");
const playIcon = document.querySelector(".play-icon");

// Variable para controlar el estado del autoplay
let autoplayEnabled = true;

const swiper = new Swiper('.slider_cards', {
    effect: "cards",
    grabCursor: true,
    autoplay: {
        delay: 3000,
        disableOnInteraction: false,
    },
    rotate: false,
    cardsEffect: {
        perSlideOffset: 15,   // Espacio entre tarjetas
        perSlideRotate: 0,   // Sin rotación
        slideShadows: false  // Sin sombras
    },
    mousewheel: {
        invert: false,
    },
    navigation: {
        nextEl: '.card-btn-next',
        prevEl: '.card-btn-prev',
    },
    pagination: {
        el: '.card-pagination',
        clickable: true,     // Permite hacer clic en la paginación
        dynamicBullets: true, // Mejora visual para muchas páginas
        type: "fraction"
    },
    on: {
        autoplayTimeLeft(s, time, progress) {
          // Actualizamos el ancho de la barra de progreso
          progressBar.style.width = `${(1 - progress) * 100}%`;
        },
        init() {
          // Inicializamos la barra de progreso
          progressBar.style.width = "100%";
          
          // Configuramos el evento click para el botón de pausa/reproducción
          autoplayToggle.addEventListener('click', function() {
            if (autoplayEnabled) {
              // Pausar el autoplay
              swiper.autoplay.stop();
              pauseIcon.style.display = 'none';
              playIcon.style.display = 'flex';
              autoplayEnabled = false;
            } else {
              // Reanudar el autoplay
              swiper.autoplay.start();
              pauseIcon.style.display = 'flex';
              playIcon.style.display = 'none';
              autoplayEnabled = true;
            }
          });
        }
    }
});
